import { makeStyles } from '@material-ui/core/styles';

export const styles = makeStyles((theme) => ({
  root: {
    width: '100%',
    margin: '0 auto',
    '& .MuiDataGrid-root .MuiDataGrid-main': {
      marginRight: '80px',
    },
    '& .MuiDataGrid-root .MuiDataGrid-footerContainer': {
      marginRight: '80px',
    },
  },
  modeSelection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '8px 0px 0px',
    width: '100%',
    height: '24px',
    left: '0px',
    top: '40px',
    backgroundColor: '#FFF',
  },
  programsMain: {
    display: 'flex',
    paddingTop: '24px',
  },
  filterSection: {
    width: '250px',
    padding: '0 24px',
  },
  programsSection: {
    width: 'calc(100% - 298px)',
  },
  programsSectionTopBar: {
    height: '40px',
    textAlign: 'left',
    margin: '8px 0 24px 0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'relative',
  },
  programOptions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'right',
    marginRight: '1rem',
    minWidth: '20%',
  },
  btnAddProgram: {
    marginLeft: '28px !important',
    width: '8rem',
  },
  imgProgramListViewMode: {
    cursor: 'pointer',
  },
  programsGridViewContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  programsGridView: {
    display: 'flex',
    flexWrap: 'wrap',
    transition: 'width 2s',
    gap: '1.5rem',
    minHeight: 'calc(100vh - 17rem)',
    alignContent: 'flex-start',
  },
  programsGridViewList: {
    display: 'flex',
    flexWrap: 'wrap',
    transition: 'width 2s',
  },
  programListView: {
    transition: 'width 2s',
  },
  userImage: {
    display: 'inline-block',
    width: '28px',
    height: '28px',
    lineHeight: '24px',
    fontWeight: 'normal',
    fontSize: '0.6rem',
    margin: '5px -5px',
    border: 'solid 3px #fff',
    borderRadius: '50px',
    backgroundColor: '#1891F6',
  },
  programNameLink: {
    cursor: 'pointer',
    color: 'rgb(2, 123, 253)',
  },
  btnRequestAccess: {
    minWidth: '132px !important',
    height: '24px !important',
    cursor: 'pointer',
    color: '#333',
    borderColor: '#BAC0D0',
    textTransform: 'none',
    fontFamily: 'Roboto Medium',
    fontSize: '0.875rem',
  },
  btnPendingAccess: {
    minWidth: '132px !important',
    height: '24px !important',
    color: '#333',
    fontFamily: 'Roboto Medium',
    fontSize: '0.875rem',
    borderColor: '#BAC0D0',
    textTransform: 'none',
  },
  paginationContainer: {
    width: 'auto',
    display: 'flex',
    justifyContent: 'center',
    flexGrow: 1,
  },
}), { name: 'program-dashboard-programs' });
